// extracted by mini-css-extract-plugin
export default {"collapsible":"styles_collapsible__R+ovD","withHeading":"styles_withHeading__3DbSt","content":"styles_content__cRybC","open":"styles_open__THaid","button":"styles_button__AcpmG"};